var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/Action/Download/Fill/Blanc",
    className: "st0-fill",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.292,16.7061 C11.385,16.7991 11.495,16.8721 11.618,16.9231 C11.74,16.9741 11.87,17.0001 12,17.0001 C12.13,17.0001 12.26,16.9741 12.382,16.9231 C12.505,16.8721 12.615,16.7991 12.708,16.7061 L15.707,13.7071 C16.098,13.3161 16.098,12.6841 15.707,12.2931 C15.316,11.9021 14.684,11.9021 14.293,12.2931 L13,13.5861 L13,4.0001 C13,3.4481 12.553,3.0001 12,3.0001 C11.447,3.0001 11,3.4481 11,4.0001 L11,13.5861 L9.707,12.2931 C9.316,11.9021 8.684,11.9021 8.293,12.2931 C7.902,12.6841 7.902,13.3161 8.293,13.7071 L11.292,16.7061 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19 L6,19 C5.447,19 5,19.448 5,20 C5,20.552 5.447,21 6,21 L18,21 C18.553,21 19,20.552 19,20 C19,19.448 18.553,19 18,19",
    id: "Fill-3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download_white.cf8fbb26cc47e7702e44d0e6d8661494.svg";
export { ForwardRef as ReactComponent };